
import { Grid } from '@mui/material';
import { useCallback, useState, useMemo } from 'react';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import Drawer, { IDefaultDrawerProps } from '../../../../components/Drawer';
import { ActionButton } from '../../../../components/Button';
import TextField from '../../../../components/TextField';
import SelectField from '../../../../components/SelectField';
import FormHelper from '../../../../helpers/FormHelper';
import { RegistrationStatusData, RegistrationStatusEnum } from '../../../../data/Enums';


interface IAccessProfileFilterProps extends IDefaultDrawerProps {
    handleApplyFilters: (formData: FormData) => void;
}


const Filters: React.FC<IAccessProfileFilterProps> = ({
    open,
    handleClose,
    handleApplyFilters
}) => {
    const { translate } = useLanguageContext();

    const [description, setDescription] = useState<string>('');
    const [registrationStatus, setRegistrationStatus] = useState<number[]>([RegistrationStatusEnum.Actived, RegistrationStatusEnum.Inactived]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        handleApplyFilters(formData);
        handleClose();
        // eslint-disable-next-line
    }, []);


    const footer = useMemo(() => {
        return <ActionButton
            action='apply'
            fullWidth={true}
            className='text-alwaysshow'
            type='submit'
        />;
        // eslint-disable-next-line
    }, [translate]);
    

    return (
        <Drawer
            anchor='right'
            open={open}
            handleClose={handleClose}
            title={translate('filter')}
            footer={footer}
            onSubmit={handleSubmit}
        >
            <Grid container>
                <Grid item xs={12}>
                    <TextField 
                        label={translate('description')} 
                        name='description' 
                        value={description} 
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                        required={false}
                    />
                </Grid>
                
                <Grid item xs={12}>
                    <SelectField
                        label={translate('situation')}
                        name='registrationStatus'
                        value={registrationStatus}
                        multiple={true}
                        required={true}
                        onChange={e => setRegistrationStatus(e.target.value)}
                        data={Object.values(RegistrationStatusData).filter(s => s.visible).map(s => {
                            return {
                                value: s.id,
                                text: translate(s.name)
                            };
                        })}
                    />
                </Grid>
            </Grid>
        </Drawer>
    );
}

export default Filters;